import type { ReactNode } from 'react';

/**
 * Non-field error banner. Rendered above the form action when a request
 * fails for a reason that doesn't map to a single input (network down,
 * rate-limited, generic 5xx). Use FormField's `error` prop for field-level
 * problems.
 *
 * Always rendered with role="alert" so screen readers announce it on appear.
 */
export function FormError({ children }: { children: ReactNode }) {
  if (!children) return null;
  return (
    <div
      role="alert"
      className="w-full rounded-[12px] border border-[#ff4479]/60 bg-[#ff0037]/15 px-4 py-3 font-['Arial',sans-serif] text-[14px] leading-tight text-[#ffe2eb]"
    >
      {children}
    </div>
  );
}
